import { Clock, Trash, ArrowClockwise } from "@phosphor-icons/react";

function fmtTime(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleString(undefined, {
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return "";
    }
}

export default function RunHistory({ runs, activeId, onSelect, onDelete, onResume }) {
    return (
        <div className="h-full flex flex-col" data-testid="run-history">
            <div className="panel-header sticky top-16">
                <div className="flex items-center gap-2">
                    <Clock size={16} weight="bold" />
                    <span className="label-kicker">Run History</span>
                </div>
                <span className="mono text-xs text-[#52525b]">{runs.length}</span>
            </div>
            <div className="overflow-y-auto flex-1">
                {runs.length === 0 && (
                    <div className="p-5 text-xs text-[#52525b]">
                        No runs yet. Start your first search.
                    </div>
                )}
                {runs.map((r) => {
                    const active = r.id === activeId;
                    return (
                        <div
                            key={r.id}
                            className={
                                "border-b border-[#e4e4e7] p-4 cursor-pointer transition-colors " +
                                (active ? "bg-[#fafafa]" : "hover:bg-[#fafafa]")
                            }
                            onClick={() => onSelect(r.id)}
                            data-testid={`run-item-${r.id}`}
                        >
                            <div className="flex items-start justify-between gap-2">
                                <div className="min-w-0">
                                    <div className="font-medium text-sm truncate">
                                        {r.category} · {r.location}
                                    </div>
                                    <div className="label-kicker mt-0.5" style={{ fontSize: 9 }}>
                                        {r.source} · {r.max_results}
                                    </div>
                                </div>
                                <div className="flex items-center gap-1">
                                    {r.status === "interrupted" && (
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onResume?.(r.id);
                                            }}
                                            className="btn-ghost"
                                            style={{ color: "#002FA7" }}
                                            data-testid={`resume-run-${r.id}`}
                                            aria-label="Resume run"
                                            title="Resume this run"
                                        >
                                            <ArrowClockwise size={14} weight="bold" />
                                        </button>
                                    )}
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onDelete(r.id);
                                        }}
                                        className="btn-ghost"
                                        data-testid={`delete-run-${r.id}`}
                                        aria-label="Delete run"
                                    >
                                        <Trash size={14} />
                                    </button>
                                </div>
                            </div>
                            <div className="flex items-center justify-between mt-2">
                                <span
                                    className={
                                        "mono text-[10px] " +
                                        (r.status === "complete"
                                            ? "text-[#002FA7]"
                                            : r.status === "failed"
                                            ? "text-[#ff3333]"
                                            : r.status === "interrupted"
                                            ? "text-[#b07000]"
                                            : "text-[#52525b]")
                                    }
                                >
                                    <span
                                        className={
                                            "dot " +
                                            (r.status === "complete"
                                                ? "dot-success"
                                                : r.status === "failed"
                                                ? "dot-error"
                                                : r.status === "interrupted"
                                                ? "dot-warning"
                                                : "dot-warning pulse-dot")
                                        }
                                    />
                                    {r.status}
                                </span>
                                <span className="mono text-[10px] text-[#a1a1aa]">
                                    {r.result_count} · {fmtTime(r.created_at)}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
